"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORTHOGRAPHIC_CAMERA_DIRECTION = void 0;
var ORTHOGRAPHIC_CAMERA_DIRECTION;
(function (ORTHOGRAPHIC_CAMERA_DIRECTION) {
    ORTHOGRAPHIC_CAMERA_DIRECTION["TOP"] = "top";
    ORTHOGRAPHIC_CAMERA_DIRECTION["BOTTOM"] = "bottom";
    ORTHOGRAPHIC_CAMERA_DIRECTION["LEFT"] = "left";
    ORTHOGRAPHIC_CAMERA_DIRECTION["RIGHT"] = "right";
    ORTHOGRAPHIC_CAMERA_DIRECTION["FRONT"] = "front";
    ORTHOGRAPHIC_CAMERA_DIRECTION["BACK"] = "back";
})(ORTHOGRAPHIC_CAMERA_DIRECTION = exports.ORTHOGRAPHIC_CAMERA_DIRECTION || (exports.ORTHOGRAPHIC_CAMERA_DIRECTION = {}));
//# sourceMappingURL=IOrthographicCamera.js.map